export const ADMIN = 'admin';
export const SUPPLIER = 'supplier';
export const DOCTOR = 'doctor';
export const MEMBER = 'member';
export const COUNCIL_MEMBER = 'council_member';
export const OWNER = 'owner';
export const ANONYMOUS = 'anonymous';
